import React, {useCallback, useEffect, useState} from "react";
import {convertirMinutosATexto, numberFormat, utcToString} from "../../../../shared/format";
import {colorIndicadores, nombreColorIndicador, tipoIndicador} from "../SeguimentoConstantes";
import {useSeguimientoMonitoreo} from "../SeguimientoMonitoreoProvider";

const TooltipGenerico = ({tooltip}) => {

    const [datos, setDatos] = useState({})

    const {
        viajes
    } = useSeguimientoMonitoreo();

    const updateDatos =useCallback (()=>{
        if (tooltip == null)
            return;

        const viaje = viajes.find(v => v.viajeId === tooltip.viajeId) || {} ;
        const tipo = tooltip.tipo;

        let datos = {}
        let indicador = (viaje.indicadores ?? {})[tipo] ?? {};
        let datosAdicionales = (viaje.indicadoresAdicional ?? {})[tipo] ?? indicador;
        const color = indicador?.color
        const minutos = Math.round(datosAdicionales?.minutos ?? 0)

        const tiempo = color === nombreColorIndicador.gris || (color === nombreColorIndicador.verde && viaje.velocidad > 5) || color == null ?
            '' :
            `${convertirMinutosATexto(minutos)}`;

        switch (tipo) {
            case tipoIndicador.velocidad:
                datos = {
                    label: 'velocidad: ',
                    value: `${viaje?.velocidad??0} km/hr${tiempo !== '' ? `, En ${colorIndicadores[color]} por ${tiempo}` : ''}`
                }
                break;
            case tipoIndicador.lastPosition:
                datos = {label: 'Ubicación: ', value: viaje.ubicacion,indicador: viaje.eta};
                break;
            case tipoIndicador.motor:
                datos = {
                    label: 'Ralenty:', value: tiempo === '' ?
                        (color === nombreColorIndicador.gris ? 'Motor Apagado' : 'En Movimiento') :
                        `Encendido desde hace ${tiempo}`
                };
                break;
            case tipoIndicador.diesel:
                datos = {
                    label: 'Ubicacion', value: indicador.ubicacion,
                    label2: 'Fecha', value2: utcToString(indicador.fecha)
                };
                break;
            case tipoIndicador.botonPanico:
                datos = {
                    label: 'Ubicacion', value: indicador.ubicacion,
                    label2: 'Fecha', value2: utcToString(indicador.fecha)
                };
                break
            case tipoIndicador.horasManejo:
                datos = {
                    label: 'Horas de Manejo Continuo: ', value: numberFormat(viaje?.horasManejo?.horas??0,0),
                    label2: 'Fecha Inicio Manejo:', value2: utcToString(viaje?.horasManejo?.fechaInicioManejo)
                };
                break
            case tipoIndicador.seguimiento:
                datos = {
                    label: 'Debe registrar el seguimiento',
                };
                break
            case tipoIndicador.despacho:
                datos = {label: 'Ubicación: ',
                    value: viaje.ubicacion,
                    indicador: color !== nombreColorIndicador.gris ? viaje.eta : ''
                };
                break;
            case tipoIndicador.detenidoZonaNoSegura:
                datos = {
                    label: indicador?.color === nombreColorIndicador.rojo ? `Detenido desde ${utcToString(indicador.fecha)}` :'',
                    label2: indicador?.color === nombreColorIndicador.rojo ? `En: ${indicador.ubicacion}` :'',
                };
                break
            default:
                break;
        }

        setDatos(datos)
    },[viajes, tooltip])

    useEffect(() => {
        updateDatos()
    }, [tooltip, updateDatos]);

    return (<>
        <span className={'t-label'}>{datos?.label}</span>
        <span className={'t-value'}>{datos?.value}</span>
        {datos?.indicador?.eta &&
            <>
                <div style={{ marginTop: "10px"}}>
                    <span className={'t-label'}>Eta:</span>
                    <span className={'t-value'}>{utcToString(datos?.indicador?.eta)} hrs</span>
                </div>

                { datos?.indicador?.minutosRetraso > 0 &&
                    <>
                        <span className={'t-label'}>Retraso:</span>
                        <span className={'t-value'}>{convertirMinutosATexto(datos?.indicador?.minutosRetraso)}</span>
                    </>
                }
                <div>
                    <span className={'t-label'}>Distancia:</span>
                    <span className={'t-value'}>{datos?.indicador?.distanciaKm} Km</span>
                </div>
            </>
        }
        {datos?.label2 &&
            <>
                <div>
                    <span className={'t-label'}>{datos?.label2}</span>
                    <span className={'t-value'}>{datos?.value2}</span>
                </div>
            </>
        }

    </>)
}
export default TooltipGenerico;